import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resumen-resagado',
  templateUrl: './lista.component.html'
})

export class ClienteComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}